import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import env1Img from '../../assets/envImages/detecht-env1@2x.png';
import env2Img from '../../assets/envImages/detecht-env2@2x.png';
import hero from '../../assets/hero/detecht-hero.jpg';
import extraimg1 from '../../assets/frames/detecht-extraimg1.png';
import extraimg2 from '../../assets/frames/detecht-extraimg2.png';
import extraimg3 from '../../assets/frames/detecht-extraimg3.png';
import footerBanner from '../../assets/envImages/detecht-footerBanner-min.jpg';

export default {
  path: '/cases/detecht',
  color: variables.detecht,
  hero: { fall: hero },
  xtra: [
    { fall: extraimg1 },
    { fall: extraimg2 },
    { fall: extraimg3 },
  ],
  environments: { env1: env1Img, env2: env2Img },
  footerBanner: { fall: footerBanner },
  title: 'Detecht',
  sideHeadingFirst: 'iOS & Android application',
  sideHeadingSecond: 'Developed in React Native',
  // quoteData: {
  //   quote: 'We App went above and beyond our expectations with this project. Creating a beautifully looking app, that lives up to our strict standards and requirements of stability and reliability. We’ll only be using We App for our future development needs.',
  //   name: 'Niklas Ohlsson',
  //   profession: 'Co-Founder & CEO, Detecht AB',
  // },
  titleBodyData: {
    0: {
      title: 'A safer bike ride',
      body: 'We\'re proud to have been working as technology partner to Detecht, a solution for automatic crash detection for motorcyclists. Through a powerful algorithm, contained within a mobile application for your phone, Detecht can identify if a driver has been in an accident, and can send an automatic call for help to emergency services.',
    },
    1: {
      title: 'Don’t be alone on the road',
      body:
  <span>
    We hope as many motorcyclists as possible will make use of this simple service, and increase their safety and well-being.
    <br />
    <br />
    Hope to see you out on the roads!
  </span>,
    },
  },
  infoTitle: 'What we built',
  infoBody:
  <span>
    Reliability was at the core of this project. Where we needed to build a stable and trust-worthy application, which could assist drivers in times of need and distress. As the app was also to be used as a social network for motorcyclists, to share routes and tips with each other, it needed to live up to high expectations of user experience and navigational simplicity.
    <br />
    <br />
    {'The project was built in '}
    <Highlight>React Native</Highlight>
    {', with integration to '}
    <Highlight>Firebase's hosting</Highlight>
    {' and '}
    <Highlight>server-side logic</Highlight>
    , for reliability and stability.
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
};
